if (!customElements.get("faq-scrolling")) {
  customElements.define(
    "faq-scrolling",
    class faqScrolling extends HTMLElement {
      constructor() {
        super();
        this.navLinks = this.querySelectorAll(".page-faqs__sidebar li a");
        this.sections = this.querySelectorAll(".fap__tab-heading");
        this.observeSections();
        this.handleNavClicks();
      }

      observeSections() {
        window.addEventListener("scroll", this.handleScroll.bind(this));
      }

      handleScroll() {
        let scrollPos = window.scrollY + 80;
        this.sections.forEach((section, index) => {
          if (
            scrollPos >= section.offsetTop &&
            scrollPos < section.offsetTop + section.offsetHeight
          ) {
            this.setActiveLink(this.navLinks[index]);
          }
        });
        if (window.innerHeight + window.scrollY >= document.body.scrollHeight) {
          this.setActiveLink(this.navLinks[this.navLinks.length - 1]);
        }
      }

      handleNavClicks() {
        this.navLinks.forEach((link) => {
          link.addEventListener("click", this.handleClick.bind(this, link));
        });
      }

      handleClick(link, event) {
        event.preventDefault();
        const targetId = link.getAttribute("href").substring(1);
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
          window.scrollTo({
            top: targetSection.offsetTop - 70,
            behavior: "smooth",
          });
          this.setActiveLink(link);
        }
      }

      setActiveLink(activeLink) {
        this.navLinks.forEach((nav) => nav.classList.remove("active"));
        if (activeLink) {
          activeLink.classList.add("active");
        }
      }
    }
  );
}